// pushEngEvent is a helper function to push generic ENG events to the dataLayer
function pushEngEvent(name, parameter, value) {
  window.pushGTMEvent({
    event: 'ENG_custom_event',
    'ENG_generic_event.parameters': {
      event_name: name,
      event_parameter: parameter,
      event_value: value,
    },
  });
}

function getEventName(diagnosticTest) {
  // map the diagnostic test names to the event names
  const testEventMap = {
    localStorageAccessible: 'localStorageUnavailable',
    isMarketingAllowed: 'marketingConsentDenied',
    googleAdUrlAccessible: 'googleAdUrlBlocked',
  };
  return testEventMap?.[diagnosticTest] ?? diagnosticTest;
}

function pushEngAnalytics() {
  // wait for obd and the diagnosticPrintOut object to be available
  if (typeof window.obd?.diagnosticPrintOut === 'undefined') {
    setTimeout(pushEngAnalytics.bind(this), 2000);
    return;
  }
  // check if any diagnostic tests are failing
  const areTestsFailing = Object.values(window.obd.diagnosticPrintOut)
    .some((result) => result === false);

  if (areTestsFailing) {
    pushEngEvent('ENG_CE_ad_fallback_triggered', 'ad_fallback_triggered', 1);
    Object.keys(window.obd.diagnosticPrintOut).forEach((diagnosticTest) => {
      const diagnosticResult = window.obd.diagnosticPrintOut[diagnosticTest];
      // if diagnostic Test has failed, push the event
      if (diagnosticResult === false) {
        const eventName = getEventName(diagnosticTest);
        pushEngEvent(`ENG_CE_${eventName}`, eventName, 1);
      }
    });
  }
}

pushEngAnalytics();
